import { WoFulfillmentList } from "./wo-fulfillment-list";
import { WoFulfillmentInfo } from "./wo-fulfillment-info";
import { WoFulfillmentEdit } from "./wo-fulfillment-edit";
import { WoFulfillmentAdd } from "./wo-fulfillment-add";

export const WoFulfillment = WoFulfillmentList;
WoFulfillment.Info = WoFulfillmentInfo;
WoFulfillment.Edit = WoFulfillmentEdit;
WoFulfillment.Add = WoFulfillmentAdd;
